/**
 * Created by rak on 05-Apr-17.
 */
'use strict';
angular.module('dashboard.driverDigitalTachoStatus', ['adf.provider'])
  .config(function (dashboardProvider) {
    dashboardProvider
      .widget('DriverDigitalTachoStatusWidget', {
        resolve: {
          title: function () {
            return 'dashBoard.fleetManagement.driverDigitalTachoStatus.driverDigitalTachoStatusTitle';
          },
          description: function () {
            return 'dashBoard.fleetManagement.driverDigitalTachoStatus.description';
          }
        },
        controller: 'DriverDigitalTachoStatusCtrl',
        templateUrl: 'components/dashboard/driverDigitalTachoStatus/driverDigitalTachoStatusWidget.tpl.html',
        isSingleInstance: true,
        reload: true,
        config: {
          mapURL: null,
          height: 450
        },
        edit: {
          templateUrl: 'components/dashboard/driverDigitalTachoStatus/driverDigitalTachoStatusWidgetEdit.tpl.html',
          reload: false,
          controller: 'DriverDigitalTachoStatusEditCtrl'
        }
      });
  }).service('DriverDigitalTachoStatusWidgetService', function () {
    var _lastSelctedWrkHrsRow = null;
    this.setLastSelectedWorkingHoursRow = function (rowdata) {
      _lastSelctedWrkHrsRow = rowdata;
    };
    this.getLastSelectedWorkingHoursRow = function () {
      return _lastSelctedWrkHrsRow;
    };

  }).controller('DriverDigitalTachoStatusCtrl', function ($scope, DriverDigitalTachoStatusWidgetService, $timeout, $translate, widgetSettingsCreatorService, DriverWrkHrsWidgetService, stateManagerService, $rootScope, AuthenticationService) {
    $scope.digitailTachoStatusDetails = {};

    $scope.isNotAuthorized = false;
    $scope.isDataNotAvailable = false;
    $scope.isWidgetPreInitFinished = false; // Pre ini animation automatically removed if anoy one of above two flags set to true
    $scope.isWidgetPostInitFinished = false;

    // var otherStyles =  widgetSettingsCreatorService.fetchCustomerWidgetStyleSettings();
    $scope.digitailTachoStatusDetails.otherStyles = widgetSettingsCreatorService.fetchCustomerWidgetStyleSettings();

    $timeout(function () {
      $rootScope.$broadcast('reqDataUpdate');
    }, 0);



    function handleRowSelect(data) {
      $scope.isDataNotAvailable = false;
      $scope.isNotAuthorized = false;

      if (data.selectedRow) {
        $scope.isOneMinuteRuleSet = data.selectedRow.tachotimecalculationstrategy === '1';
        $scope.isFMSTimestampSet = data.selectedRow.lastfmstimestamp !== '0' && data.selectedRow.lastfmstimestamp !== '---';
        data.selectedRow = Object.assign({}, data.selectedRow);
        data.selectedRow.driverdesc = data.selectedRow.driverdesc.length > 0 ? data.selectedRow.driverdesc : '---';
        $scope.digitailTachoStatusDetails = data.selectedRow;
        $scope.digitailTachoStatusDetails.currentStatus = $translate.instant('dashBoard.fleetManagement.driverDigitalTachoStatus.currentStatus');
        DriverDigitalTachoStatusWidgetService.setLastSelectedWorkingHoursRow(data.selectedRow);
      } else {
        $scope.isDataNotAvailable = true;
      }
      $scope.dataLoadingFinished = true;
    }

    var loadDependentDataFromServer = function (deviceID) {
      $scope.isDataNotAvailable = false;
      $scope.isNotAuthorized = false;
      DriverWrkHrsWidgetService.getDriverWorkingHoursListForDevice(deviceID).then(function (result) {
        if (result.dataList && result.dataList.length === 1) {
          handleRowSelect({ selectedRow: result.dataList[0] });
        } else {
          $scope.isDataNotAvailable = true;
        }
      });
    };

    // Modification for the Loading Imporvement
    var getSetData = function (widget) {
      var loginID = AuthenticationService.GetLoginID();
      widget = loginID.Account+'_'+loginID.username+'_'+widget;
      var stateData = stateManagerService.getStateData();
      var set = stateData && stateData[widget] ? stateData[widget] : {};
      return set;
    };
    var maxGetInitialDataRetries = 30;
    var currentParentRowResEvent = $scope.$on('resDataUpdate', function (event, data) {
      if (maxGetInitialDataRetries < 0 || $scope.isWidgetPostInitFinished) {
        currentParentRowResEvent();
        return;
      }
    //  console.info(' Digital Tacho Status Widget Requesting Parent for Data ..');
      --maxGetInitialDataRetries;
      var set = getSetData(data.widget);
      var selectedParentTabRowValues = set['tab_' + data.activeTab + '_selectedRow'];


      // parents First tab must always retrun a  valid selected row
      if ((data.activeTab === 0 && !_.isEmpty(selectedParentTabRowValues) && !_.isEmpty(selectedParentTabRowValues.value)) || (data.activeTab > 0 && !_.isEmpty(selectedParentTabRowValues))) {
        $scope.isWidgetPreInitFinished = true;
        $scope.isWidgetPostInitFinished = true;
        _handleDataUpdate(data.dashboardName, data.activeTab, selectedParentTabRowValues.value, data.widget);

      } else {
        // Repeatedly try to get the data from parent .
        if (maxGetInitialDataRetries > 0) {
          $timeout(function () {
            if (!$scope.isWidgetPostInitFinished) {
              $rootScope.$broadcast('reqDataUpdate');
            }
          }, 100);
        } else {
          console.warn('Max Retries exceeded to get the current Parent data for Digital Tacho Status Widget..');
          $scope.isWidgetPreInitFinished = true;
          $scope.isWidgetPostInitFinished = true;
          $scope.isDataNotAvailable = true;
          currentParentRowResEvent();
        }
      }

    });

    var dataStateUpdateListener = $scope.$on('dataStateUpdate', function (event, data) {
      if ($scope.isWidgetPostInitFinished) {
        var set = getSetData(data.widget);
        _handleDataUpdate(data.dashboardName, data.activeTab, set['tab_' + data.activeTab + '_selectedRow'].value, data.widget);
      } else {
        //console.log('Ignoring dataState update from widget: ' + data.widget);
      }

    });

    function _handleDataUpdate(dashboardName, tabNumber, rowData, widgetName) {
      var set;

      switch (dashboardName) {
        case 'dashboard.driverWrkHrsDashboard': // contains only tab 0
          switch (tabNumber) {
            case 0:
              handleRowSelect({ selectedRow: rowData });
              break;
          }
          break;
        case 'dashboard.tachohistory': // contains only tab 0
          switch (tabNumber) {
            case 0:
              if (!_.isEmpty(rowData)) {
                $scope.isDataNotAvailable = false;
                $scope.isNotAuthorized = false;
                $scope.digitailTachoStatusDetails = rowData;
                $scope.isOneMinuteRuleSet = $scope.digitailTachoStatusDetails.tachotimecalculationstrategy === '1';
                $scope.isFMSTimestampSet = $scope.digitailTachoStatusDetails.lastfmstimestamp !== '0' && $scope.digitailTachoStatusDetails.lastfmstimestamp !== '---';
                if ($scope.digitailTachoStatusDetails && $scope.digitailTachoStatusDetails.workinghours) {
                  $scope.digitailTachoStatusDetails.driverworkhours = $scope.digitailTachoStatusDetails.workinghours;
                } else {
                  $scope.isDataNotAvailable = true;
                }
                $scope.dataLoadingFinished = true;
              } else {
                $scope.isDataNotAvailable = true;
              }

              break;

          }
          break;
        case 'dashboard.fmsDashboard':
        case 'dashboard.vehicleList':
          switch (tabNumber) {
            case 0: // first tab use device id to  load data from server
              set = getSetData(widgetName);
              rowData = set['tab_' + 0 + '_selectedRow'];
              if (!_.isEmpty(rowData.value)) {
                loadDependentDataFromServer(rowData.value.deviceid);

              } else {
                $scope.isDataNotAvailable = true;
              }
              break;
            case 1: // use the Service stored Data
            case 2:
            case 3:
              rowData = DriverDigitalTachoStatusWidgetService.getLastSelectedWorkingHoursRow();
              if (!_.isEmpty(rowData)) {
                handleRowSelect({ selectedRow: rowData });
              } else {
                $scope.isDataNotAvailable = true;
              }
              break;
          }
          break;

      }
    }
    $scope.$on('$destroy', function () {
      dataStateUpdateListener();
      currentParentRowResEvent();
    });

  }).controller('DriverDigitalTachoStatusEditCtrl', function () {
  });



// WEBPACK FOOTER //
// ./.tmp/components/dashboard/driverDigitalTachoStatus/driverDigitalTachoStatusWidget.js